import {
    action,
    actionComplete,
    calanderPoa,
    caller,
    callerWhite,
    copy,
    DownArrowBlack,
    email,
    filterBlack,
    halfPale,
    halfPaleHover,
    fullPale,
    fullPaleHover,
    group,
    groupWhite,
    pale,
    poaExpired,
    poaExpiredHover,
    telephone,
    UpArrowBlack,
} from '@/assets'
import { DateRange, MultiSelect, MultiSelectNoInput } from '@/components/Atoms'
import MultiSelectPopUp from '@/components/Atoms/MultiSelectPopup'
import { DateRangeType } from '@/components/survey/SurveyModel/types/commonTypes'
import {
    DropDownOption,
    IPoaModalItem,
} from '@/components/survey/SurveyModel/types/nodeTypes'
import {
    ListTypes,
    POATypes,
    QuestionnaireResponseStatus,
    WaitingListRecordStatuses,
} from '@/constants/enums'
import { RootState } from '@/reducers/store'
import {
    useGetAnae,
    useGetNameChiOptions,
    useGetNameOpcs4OperationsOptions,
    useGetPoaActions,
    useGetPoaListData,
    useGetIntendedManagement,
    useGetHospitals,
    useGetPriorities,
    useGetSpecialities,
    useGetSurgeons,
    useResetAllPoaSurveyLists,
    useResetNameChi,
    useResetOperationProcedures,
} from '@/state/survey/poaSurveySlice'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { debounce } from 'lodash'
import moment from 'moment'
import React, {
    FC,
    memo,
    useEffect,
    useMemo,
    useRef,
    useState,
} from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { MultiValue } from 'react-select'
import copyToClipboard from "copy-to-clipboard"
import PoaListModal from '@/components/PoaComponents/PoaListModal'

interface Header {
    title: string
    code: string
    icons: string[]
    sortKey?: string
    menuPositionOffset?: {
        top?: string
        left?: string
        transform?: string
        minWidth?: string
    }
}

interface ExpiryMeta {
    display: string
    filterValue: string
    isExpired: boolean
}

const OUTCOME_FILTER_OPTIONS: DropDownOption[] = [
    { value: '0', label: 'All' },
    { value: 'TBD', label: 'TBD' },
    { value: 'Defer', label: 'Defer' },
    { value: 'Pass', label: 'Pass' },
    { value: 'Fail', label: 'Fail' },
]

dayjs.extend(utc)
const PoaList: React.FC = memo(() => {
    const navigate = useNavigate()
    const location = useLocation()
    /// Start: POA type model
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [modalSelection, setModalSelection] = useState(0)
    const [questionnaireResponseId, setQuestionnaireResponseId] = useState(0)
    const [waitingListRecordId, setWaitingListRecordId] = useState(0)
    const [poaListSelectedPoaDate, setpoaListSelectedPoaDate] = useState('')
    const [name, setName] = useState('')

    /// End: POA type model
    interface Option {
        value: string
        label: string
    }
    interface FilterMap {
        specialities: MultiValue<Option> | null
        surgeons: MultiValue<Option> | null
        poaActions: MultiValue<Option> | null
        priority: MultiValue<Option> | null
        anae: MultiValue<Option> | null
        ipDsu: MultiValue<Option> | null
        poaTypes: MultiValue<Option> | null
        poaStatuses: MultiValue<Option> | null
        hospital: MultiValue<Option> | null
        outcome: MultiValue<Option> | null
        expiry: MultiValue<Option> | null
        dateRange: DateRangeType | null
        nameChi: MultiValue<Option> | null
        operationProcedures: MultiValue<Option> | null
        poa: MultiValue<Option> | null
    }
    const {
        specialities,
        surgeons,
        poaActions,
        priorities,
        anae,
        poaData,
        nameChi,
        operationProcedures,
        intendedManagement,
        hospitals,
    } = useSelector((state: RootState) => state.poaSurvey)
    const [specialityOptions, setSpecialityOptions] = useState<
        DropDownOption[]
    >([])
    const [surgeonOptions, setSurgeonOptions] = useState<DropDownOption[]>([])
    const [poaActionOptions, setPoaActionOptions] = useState<DropDownOption[]>(
        []
    )
    const [priorityOptions, setPriorityOptions] = useState<DropDownOption[]>([])
    const [anaeOptions, setAnaeOptions] = useState<DropDownOption[]>([])
    const [nameChiOptions, setNameChiOptions] = useState<DropDownOption[]>([])

    const typeOptions: DropDownOption[] = [
        { value: '0', label: 'All' },
        { value: '1', label: 'Phone call' },
        { value: '2', label: 'Hospital clinic' },
    ]
    const statusOptions: DropDownOption[] = [
        { value: '0', label: 'All' },
        { value: '4', label: 'In progress' },
        { value: '5', label: 'Complete' },
        { value: '6', label: 'Expired' },
    ]

    const [ipDsuOptions, setIpDsuOptions] = useState<DropDownOption[]>([])

    const [activeFilterKey, setActiveFilterKey] = useState<string | null>(null)

    const [selectedSpecialities, setSelectedSpecialities] =  useState<FilterMap['specialities']>(null)
    const [selectedSurgeons, setSelectedSurgeons] = useState<FilterMap['surgeons']>(null)
    const [selectedPoaActions, setSelectedPoaActions] =  useState<FilterMap['poaActions']>(null)
    const [selectedPriorities, setSelectedPriorities] = useState<FilterMap['priority']>([])
    const [selectedAnae, setSelectedAnae] = useState<FilterMap['anae']>([])
    const [selectedIpDsu, setSelectedIpDsu] = useState<FilterMap['ipDsu']>([])
    const [selectedPoaTypes, setSelectedPoaTypes] = useState<FilterMap['poaTypes']>([])
    const [selectedPoaStatuses, setSelectedPoaStatuses] = useState<FilterMap['poaStatuses']>([])
    const [selectedHospital, setSelectedHospital] = useState<FilterMap['hospital']>([])
    const [selectedOutcome, setSelectedOutcome] = useState<FilterMap['outcome']>([])
    const [selectedExpiryDateRange, setSelectedExpiryDateRange] =
        useState<DateRangeType | null>(null)
    const [selectedNameChi, setSelectedNameChi] =useState<FilterMap['nameChi']>(null)
    const [selectedDateRange, setSelectedDateRange] =useState<DateRangeType | null>(null)
    const [selectedScheduledDateRange, setSelectedScheduledDateRange] =
        useState<DateRangeType | null>(null)

    const [operationProcedureOptions, setOperationProcedureOptions] = useState<DropDownOption[]>([])
    const [selectedOperationProcedures, setSelectedOperationProcedures] = useState<FilterMap['nameChi']>(null)
    const [selectedPoaStatusFilter, setSelectedPoaStatusFilter] =
        useState<FilterMap['poa']>([])

    const [hospitalOptions, setHospitalOptions] = useState<DropDownOption[]>([])
    const poaStatusFilterOptions: DropDownOption[] = [
        { value: '0', label: 'All' },
        { value: 'notStarted', label: 'Not started' },
        { value: 'inProgress', label: 'In progress' },
        { value: 'complete', label: 'Complete' },
        { value: 'expired', label: 'Expired' },
    ]

    const getNameOpcs4OperationsOptions = useGetNameOpcs4OperationsOptions()

    const [sortByColumn, setSortByColumn] = useState<string | null>(null)
    const [sortOrder, setSortOrder] = useState<'asc' | 'desc' | null>(null)
    const serverListSortKey = useMemo(
        () =>
            sortByColumn && sortOrder
                ? `${sortByColumn}:${sortOrder}`
                : 'default',
        [sortByColumn, sortOrder]
    )

    const selectedReferenceCodeIds = useMemo(() => {
        const selectedIds =
            selectedIpDsu?.map((s) => Number(s.value)).filter((id) => !Number.isNaN(id)) ??
            []
        const allNonAllReferenceCodeIds =
            intendedManagement?.filter((im) => im.id !== 0).map((im) => im.id) ?? []

        if (!selectedIds.length) {
            return undefined
        }

        if (selectedIds.includes(0)) {
            return allNonAllReferenceCodeIds.length
                ? allNonAllReferenceCodeIds
                : undefined
        }

        const ids = selectedIds.filter((id) => id !== 0)
        return ids.length ? ids : undefined
    }, [selectedIpDsu, intendedManagement])

    const selectedHospitalIds = useMemo(() => {
        const selectedIds =
            selectedHospital?.map((s) => Number(s.value)).filter((id) => !Number.isNaN(id)) ??
            []
        const allIds = hospitals?.map((h) => h.id).filter((id) => id !== 0) ?? []

        if (!selectedIds.length) {
            return undefined
        }

        if (selectedIds.includes(0)) {
            return allIds.length ? allIds : undefined
        }

        const ids = selectedIds.filter((id) => id !== 0)
        return ids.length ? ids : undefined
    }, [selectedHospital, hospitals])

    const selectedTeamReviewOutcomes = useMemo(() => {
        const selectedVals = selectedOutcome?.map((o) => o.value) ?? []
        const allNonAllOutcomes = OUTCOME_FILTER_OPTIONS.filter(
            (o) => o.value !== '0'
        ).map((o) => String(o.value))

        if (!selectedVals.length) {
            return undefined
        }

        if (selectedVals.includes('0')) {
            return allNonAllOutcomes.length ? allNonAllOutcomes : undefined
        }

        const vals = selectedVals.filter((v) => v !== '0')
        return vals.length ? vals : undefined
    }, [selectedOutcome])

    /**
     * Waiting-list filter `QuestionnaireStatusIds`: merges the workflow status multiselect (4 / 5 / 6, or all)
     * with the POA column filter. Column values map to questionnaire response status ids; not-started also
     * sends null so the API can match rows with no active questionnaire. If both filters apply, the numeric
     * sets are intersected; an empty intersection becomes [-1] so no rows match. Selecting "All" on the
     * column omits this constraint.
     */
    const questionnaireStatusIds = useMemo(():
        | (number | null)[]
        | undefined => {
        const workflowRaw = selectedPoaStatuses ?? []
        const hasAllWorkflow =
            !workflowRaw.length ||
            workflowRaw.some((s) => String(s.value) === '0')
        const workflowIds = hasAllWorkflow
            ? undefined
            : workflowRaw
                  .filter((s) => String(s.value) !== '0')
                  .map((s) => Number(s.value))
                  .filter((n) => !Number.isNaN(n))

        const colVals = (selectedPoaStatusFilter ?? []).map((s) => s.value)
        const hasColumn =
            colVals.length > 0 && !colVals.includes('0')

        const columnIds: (number | null)[] = []
        if (hasColumn) {
            const add = (x: number | null) => {
                if (!columnIds.some((y) => y === x)) columnIds.push(x)
            }
            if (colVals.includes('notStarted')) {
                add(QuestionnaireResponseStatus.Sent)
                add(QuestionnaireResponseStatus.Started)
                add(QuestionnaireResponseStatus.PatientCompleted)
                add(null)
            }
            if (colVals.includes('inProgress')) {
                add(QuestionnaireResponseStatus.POA)
            }
            if (colVals.includes('complete')) {
                add(QuestionnaireResponseStatus.Complete)
            }
            if (colVals.includes('expired')) {
                add(QuestionnaireResponseStatus.Expired)
            }
        }

        const fromColumn =
            hasColumn && columnIds.length ? columnIds : undefined
        const fromWorkflow =
            !hasAllWorkflow && workflowIds?.length ? workflowIds : undefined

        if (!fromWorkflow && !fromColumn) return undefined
        if (fromWorkflow && !fromColumn) return fromWorkflow
        if (!fromWorkflow && fromColumn) return fromColumn

        const wfSet = new Set(fromWorkflow!)
        const colArr = fromColumn!
        const colNums = colArr.filter((x): x is number => x != null)
        const numInt = colNums.filter((n) => wfSet.has(n))
        if (!numInt.length) {
            return [-1]
        }
        return numInt
    }, [selectedPoaStatuses, selectedPoaStatusFilter])

    const [nameChiSearchInput, setNameChiSearchInput] = useState('');
    const [opcsSearchInput, setOpcsSearchInput] = useState('');


    const getPoaListListData = useGetPoaListData()
    const getIntendedManagementOptions = useGetIntendedManagement()
    const getHospitalsList = useGetHospitals()
    const getSpecialities = useGetSpecialities()
    const getSurgeons = useGetSurgeons()
    const getPoaActions = useGetPoaActions()
    const getPriorities = useGetPriorities()
    const resetNameChi = useResetNameChi()
    const resetOpcs = useResetOperationProcedures()
    const getAnae = useGetAnae()
    const resetAllLists = useResetAllPoaSurveyLists()

    const getNameChiOptions = useGetNameChiOptions()

    const shouldRunPoaDataEffect = useRef(false)

    const handleFilterChange = (
        type: keyof FilterMap,
        selected: MultiValue<Option>
    ) => {
        switch (type) {
            case 'specialities':
                setSelectedSpecialities(selected)
                break
            case 'surgeons':
                setSelectedSurgeons(selected)
                break
            case 'poaActions':
                setSelectedPoaActions(selected)
                break
            case 'priority':
                setSelectedPriorities(selected)
                break
            case 'anae':
                setSelectedAnae(selected)
                break
            case 'ipDsu':
                setSelectedIpDsu(selected)
                break
            case 'poaTypes':
                setSelectedPoaTypes(selected)
                break
            case 'poaStatuses':
                setSelectedPoaStatuses(selected)
                break
            case 'hospital':
                setSelectedHospital(selected)
                break
            case 'outcome':
                setSelectedOutcome(selected)
                break
            case 'dateRange':
                setSelectedPoaStatuses(selected)
                break
            case 'nameChi':
                setSelectedNameChi(selected)
                break
            case 'operationProcedures':
                setSelectedOperationProcedures(selected)
                break
            case 'poa':
                setSelectedPoaStatusFilter(selected)
                break
        }
    }

    useEffect(() => {
        getSpecialities(ListTypes.PoaList)
        getSurgeons(ListTypes.PoaList)
        getPoaActions()
        getPriorities(ListTypes.PoaList)
        getAnae(ListTypes.PoaList)
        getIntendedManagementOptions()
        getHospitalsList()
        getPoaListListData(
            [], //specialities
            [], //surgeons
            [], //actions
            selectedPriorities?.map((s) => Number(s.value)), //priorityIds
            [], //operationProcedureIds
            selectedAnae?.map((s) => Number(s.value)), //anaestheticTypeIds
            selectedPoaTypes?.map((s) => Number(s.value)), //poaTypes
            questionnaireStatusIds,
            [
                WaitingListRecordStatuses.POA,
                WaitingListRecordStatuses.Complete,
                WaitingListRecordStatuses.Expired,
            ], //waitingListRecordStatusIds
            [], //CHIs
            undefined, //poaStartDate
            undefined, //poaEndDate
            undefined, //operationListStartDate
            undefined, //operationListEndDate
            undefined, //referenceCodeIds
            undefined, //hospitalIds
            undefined, //teamReviewOutcomes
            undefined, //expirationDateStartDate
            undefined, //expirationDateEndDate
            sortByColumn,
            sortOrder
        )
        return () => {
            resetAllLists()
            setIsModalOpen(false);
            setModalSelection(0);
            setQuestionnaireResponseId(0);
            setWaitingListRecordId(0);
            setpoaListSelectedPoaDate('');
            setName('');
            setActiveFilterKey(null);
            setSelectedSpecialities(null);
            setSelectedSurgeons(null);
            setSelectedPoaActions(null);
            setSelectedPriorities([]);
            setSelectedAnae([]);
            setSelectedIpDsu([]);
            setSelectedPoaTypes([]);
            setSelectedPoaStatuses([]);
            setSelectedHospital([]);
            setSelectedOutcome([]);
            setSelectedExpiryDateRange(null);
            setSelectedNameChi(null);
            setSelectedDateRange(null);
            setSelectedScheduledDateRange(null);
            setSelectedOperationProcedures(null);
            setSelectedPoaStatusFilter([]);
            setSortByColumn(null);
            setSortOrder(null);
        }
    }, [])

    useEffect(() => {
        return () => {
            setNameChiSearchInput('');
            setOpcsSearchInput('');
        };
    }, []);

    useEffect(() => {
        setIsModalOpen(false);
        setModalSelection(0);
        setSurgeonOptions([]);
        setPriorityOptions([]);
        setAnaeOptions([]);
        setNameChiOptions([]);
        setOperationProcedureOptions([]);
        setSelectedSpecialities(null);
        setSelectedSurgeons(null);
        setSelectedIpDsu([]);
        setSelectedHospital([]);
        setSelectedOutcome([]);
        setSelectedExpiryDateRange(null);
        setSelectedPoaStatusFilter([]);
        resetAllLists();
    }, [location.pathname]);

    useEffect(() => {
        const isDateFilterOpen =
            activeFilterKey === 'POADate' ||
            activeFilterKey === 'scheduledDate' ||
            activeFilterKey === 'expiry'

        if (!isDateFilterOpen) {
            return
        }

        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as HTMLElement | null
            if (!target) return

            if (target.closest('.date-picker-popup')) {
                return
            }

            if (target.closest('.filter-icon-wrap')) {
                return
            }

            setActiveFilterKey(null)
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [activeFilterKey])
    

    useEffect(() => {
        if (!specialities?.length) return
        setSpecialityOptions([
            { value: '0', label: 'All specialities' },
            ...specialities.map(
                ({ id, name }): DropDownOption => ({
                    value: id,
                    label: name,
                })
            ),
        ])
    }, [specialities])

    useEffect(() => {
        if (!surgeons?.length) return
        setSurgeonOptions([
            { value: '0', label: 'All surgeons' },
            ...surgeons.map(
                ({ id, name }): DropDownOption => ({
                    value: id,
                    label: name,
                })
            ),
        ])
    }, [surgeons])

    useEffect(() => {
        if (!poaActions?.length) return
        setPoaActionOptions([
            { value: '0', label: 'All actions' },
            ...poaActions.map(
                ({ id, name }): DropDownOption => ({
                    value: id,
                    label: name,
                })
            ),
        ])
    }, [poaActions])

    useEffect(() => {
        if (!priorities?.length) return
        setPriorityOptions([
            { value: '0', label: 'All' },
            ...priorities.map(
                ({ id, name }): DropDownOption => ({
                    value: id,
                    label: name,
                })
            ),
        ])
    }, [priorities])

    useEffect(() => {
        if (!anae?.length) return
        setAnaeOptions([
            { value: '0', label: 'All' },
            ...anae.map(
                ({ id, code }): DropDownOption => ({
                    value: id,
                    label: code,
                })
            ),
        ])
    }, [anae])

    useEffect(() => {
        if (!intendedManagement?.length) return
        setIpDsuOptions(
            intendedManagement.map(({ id, code }) => ({
                value: String(id),
                label: code,
            }))
        )
    }, [intendedManagement])

    useEffect(() => {
        let chiOptions: any[] = []
        if (nameChi?.length) {
            chiOptions = [...nameChi]
        }
        if (selectedNameChi && selectedNameChi.length) {
            //chiOptions = [...new Set([...chiOptions, ...selectedNameChi])]
            const merged = [...chiOptions, ...selectedNameChi]
            chiOptions = Array.from(
                new Map(merged.map((item) => [item.value, item])).values()
            )
        }
        setNameChiOptions(chiOptions)

        if (!nameChi?.length) return
    }, [nameChi, selectedNameChi])

    useEffect(() => {
        let opcOptions: any[] = [];
        
        if (operationProcedures?.length) {
            const mergedOpcOptions = [
                ...operationProcedures.map(({ id, code, name }): any => ({
                    value: id,
                    label: code + ' - ' + name,
                })),
            ];
            opcOptions = [...mergedOpcOptions];
        }
    
        if (selectedOperationProcedures?.length) {
            const merged = [...opcOptions, ...selectedOperationProcedures];
            opcOptions = Array.from(new Map(merged.map((item) => [item.value, item])).values());
        }
        
        setOperationProcedureOptions(opcOptions);
        if (!operationProcedures?.length) return
    }, [operationProcedures, selectedOperationProcedures]);

    const normalizeOutcomeValue = (raw: any): string => {
        const s = raw == null ? '' : String(raw).trim()
        return s ? s : 'TBD'
    }

    const getOutcomeValue = (item: any): string =>
        normalizeOutcomeValue(item?.teamReviewOutcome)

    const getHospitalValue = (item: any): string => {
        const rawValue = item?.hospitalName

        if (rawValue == null) {
            return '--'
        }

        const value = String(rawValue).trim()
        return value ? value : '--'
    }

    const getRawExpiryValue = (item: any): any =>
        item?.expirationDateTime ??
        (item as { ExpirationDateTime?: string })?.ExpirationDateTime

    const getExpiryMeta = (raw: any): ExpiryMeta => {
        if (!raw) {
            return { display: '--', filterValue: '', isExpired: false }
        }

        const parsed = dayjs.utc(raw)
        if (!parsed.isValid()) {
            return { display: '--', filterValue: '', isExpired: false }
        }

        const localDate = parsed.local()
        const todayStart = dayjs().startOf('day')
        const expiryStart = localDate.startOf('day')

        return {
            display: localDate.format('DD/MM/YYYY'),
            filterValue: localDate.format('YYYY-MM-DD'),
            isExpired: todayStart.isSame(expiryStart) || todayStart.isAfter(expiryStart),
        }
    }

    useEffect(() => {
        const debounced = debounce(() => {
            if (shouldRunPoaDataEffect.current) {
                getPoaListListData(
                    selectedSpecialities?.map((s) => Number(s.value)) ?? [], //specialities
                    selectedSurgeons?.map((s) => Number(s.value)) ?? [], //surgeons
                    selectedPoaActions?.map((s) => s.label) ?? [], //actions
                    selectedPriorities?.map((s) => Number(s.value)), //priorityIds
                    selectedOperationProcedures?.map((s) => Number(s.value)), //operationProcedureIds
                    selectedAnae?.map((s) => Number(s.value)), //anaestheticTypeIds
                    selectedPoaTypes?.map((s) => Number(s.value)), //poaTypes
                    questionnaireStatusIds,
                    [
                        WaitingListRecordStatuses.POA,
                        WaitingListRecordStatuses.Complete,
                        WaitingListRecordStatuses.Expired,
                    ], //waitingListRecordStatusIds
                    selectedNameChi?.map((item) => item.value), //CHIs
                    selectedDateRange
                        ? new Date(selectedDateRange?.start)
                        : undefined, //poaStartDate
                    selectedDateRange
                        ? new Date(selectedDateRange?.end)
                        : undefined, //poaEndDate
                    selectedScheduledDateRange
                        ? new Date(selectedScheduledDateRange?.start)
                        : undefined,
                    selectedScheduledDateRange
                        ? new Date(selectedScheduledDateRange?.end)
                        : undefined,
                    selectedReferenceCodeIds,
                    selectedHospitalIds,
                    selectedTeamReviewOutcomes,
                    selectedExpiryDateRange
                        ? new Date(selectedExpiryDateRange.start)
                        : undefined,
                    selectedExpiryDateRange
                        ? new Date(selectedExpiryDateRange.end)
                        : undefined,
                    sortByColumn,
                    sortOrder
                )
            } else {
                shouldRunPoaDataEffect.current = true
            }
        }, 500)
        debounced()
        return () => debounced.cancel()
    }, [
        selectedSpecialities,
        selectedSurgeons,
        selectedPoaActions,
        selectedPriorities,
        selectedAnae,
        selectedIpDsu,
        selectedReferenceCodeIds,
        selectedHospitalIds,
        selectedTeamReviewOutcomes,
        selectedPoaTypes,
        questionnaireStatusIds,
        selectedDateRange,
        selectedScheduledDateRange,
        selectedExpiryDateRange,
        selectedNameChi,
        selectedOperationProcedures,
        serverListSortKey,
    ])

    const toggleSort = (column: string | undefined) => {
        if (!column) {
            return
        }
        if (sortByColumn === column) {
            if (sortOrder === 'asc') {
                setSortOrder('desc')
            } else if (sortOrder === 'desc') {
                setSortByColumn(null)
                setSortOrder(null)
            } else {
                setSortOrder('asc')
            }
        } else {
            setSortByColumn(column)
            setSortOrder('asc')
        }
    }

    const openModal = () => setIsModalOpen(true)
    const closeModal = (poaModalItem: IPoaModalItem | null) => {
        if (poaModalItem) {
            const found: any = poaData.find(
                (item: any) => item.id === poaModalItem.id
            )
            if (found) {
                found.questionnaireResponsePOADateTime =
                    poaModalItem.poaDateTime
                found.questionnaireResponsePOAType = poaModalItem.poaType
            }
        }
        setIsModalOpen(false)
    }

    const navigateToPoa = (
        questionnaireId: number,
        questionnaireResponseId: number,
        questionnaireResponseInformaitionPackId: number,
        questionnaireResponseStatusId: number,
        waitingListRecordId: number
    ) => {
        navigate(
            `/poa/${questionnaireId}/${questionnaireResponseStatusId}/${questionnaireResponseInformaitionPackId}/${questionnaireResponseId}/${questionnaireId}/${waitingListRecordId}`
        )
    }

    const getSelectedValue = (code: string): MultiValue<Option> => {
        switch (code) {
            case 'priority':
                return selectedPriorities ?? []
            case 'anae':
                return selectedAnae ?? []
            case 'ipDsu':
                return selectedIpDsu ?? []
            case 'hospital':
                return selectedHospital ?? []
            case 'outcome':
                return selectedOutcome ?? []
            case 'poaTypes':
                return selectedPoaTypes ?? []
            case 'poaStatuses':
                return selectedPoaStatuses ?? []
            case 'nameChi':
                return selectedNameChi ?? []
            case 'poa':
                return selectedPoaStatusFilter ?? []
            default:
                return []
        }
    }

    const headers: Header[] = [
        {
            title: 'Priority',
            code: 'priority',
            icons: ['filter', 'sortBy'],
            sortKey: 'Priority',
            menuPositionOffset: {
                top: '11px',
                left: '-60px',
                minWidth: '160px',
            }
        },
        {
            title: 'Name/CHI',
            code: 'nameChi',
            icons: ['filter', 'sortBy'],
            sortKey: 'Name',
            menuPositionOffset: {
                top: '12px',
                left: '-85px'
            },
        },
        {
            title: 'OPCS-4/operation',
            code: 'operationProcedures',
            icons: ['filter', 'sortBy'],
            sortKey: 'OPCSCode',
            menuPositionOffset: {
                top: '12px',
                left: '-137px'
            },
        },
        {
            title: 'Scheduled',
            code: 'scheduledDate',
            icons: ['filter', 'sortBy'],
            sortKey: 'Scheduled',
            menuPositionOffset: { top: '12px', left: '-82px' },
        },
        {
            title: 'Hospital',
            code: 'hospital',
            icons: ['filter'],
            menuPositionOffset: {
                top: '11px',
                left: '-66px',
                minWidth: '160px',
            },
        },
        {
            title: 'Anae',
            code: 'anae',
            icons: ['filter'],
            menuPositionOffset: {
                top: '11px',
                left: '-46px',
                minWidth: '160px',
            },
            sortKey: 'Anae',
        },
        {
            title: 'IP/DSU',
            code: 'ipDsu',
            icons: ['filter'],
            menuPositionOffset: {
                top: '11px',
                left: '-62px',
                minWidth: '160px',
            },
            sortKey: 'IPDSU',
        },
        {
            title: '',
            code: 'separator',
            icons: [],
        },
        {
            title: 'POA appt.',
            code: 'POADate',
            icons: ['filter', 'sortBy'],
            sortKey: 'POADate',
            menuPositionOffset: {
                top: '12px',
                left: '-79px',
            },
        },
        {
            title: 'Type',
            code: 'poaTypes',
            icons: ['filter'],
            menuPositionOffset: {
                top: '11px',
                left: '-43px',
                minWidth: '160px',
            },
        },
        {
            title: 'Outcome',
            code: 'outcome',
            icons: ['filter'],
            menuPositionOffset: {
                top: '11px',
                left: '-72px',
                minWidth: '160px',
            },
        },
        {
            title: 'Expiry',
            code: 'expiry',
            icons: ['filter', 'sortBy'],
            menuPositionOffset: { top: '12px', left: '-190px' },
            sortKey: 'ExpirationDate',
        },
        {
            title: 'POA',
            code: 'poa',
            icons: ['filter'],
            menuPositionOffset: {
                top: '11px',
                left: '',
                transform: 'translateX(-64%)',
                minWidth: '160px',
            },
        },
    ]

    const [hoveredTitle, setHoveredTitle] = useState<string | null>(null)

    const handleToggleFilter = (type: string) => {
        setActiveFilterKey((prev) => (prev === type ? null : type))
    }

    const getOptionsByCode = (code: string): DropDownOption[] => {
        switch (code) {
            case 'priority':
                return priorityOptions
            case 'anae':
                return anaeOptions
            case 'ipDsu':
                return ipDsuOptions
            case 'hospital':
                return hospitalOptions
            case 'poaTypes':
                return typeOptions
            case 'poaStatuses':
                return statusOptions
            case 'outcome':
                return OUTCOME_FILTER_OPTIONS
            case 'poa':
                return poaStatusFilterOptions
            case 'nameChi':
                return nameChiOptions
            case 'operationProcedures':
                return operationProcedureOptions
            default:
                return []
        }
    }

    const handleDateRangeChange = (value: DateRangeType | null) => {
        if (value) {
            value.start = moment(value.start, 'DD-MM-YYYY').format('YYYY-MM-DD')
            value.end = moment(value.end, 'DD-MM-YYYY').format('YYYY-MM-DD')
            setSelectedDateRange(value)
            setActiveFilterKey(null)
        } else {
            setSelectedDateRange(null)
            setActiveFilterKey(null)
        }
    }

    const handleScheduledDateRangeChange = (value: DateRangeType | null) => {
        if (value) {
            value.start = moment(value.start, 'DD-MM-YYYY').format('YYYY-MM-DD')
            value.end = moment(value.end, 'DD-MM-YYYY').format('YYYY-MM-DD')
            setSelectedScheduledDateRange(value)
            setActiveFilterKey(null)
        } else {
            setSelectedScheduledDateRange(null)
            setActiveFilterKey(null)
        }
    }

    const handleExpiryDateRangeChange = (value: DateRangeType | null) => {
        if (value) {
            value.start = moment(value.start, 'DD-MM-YYYY').format('YYYY-MM-DD')
            value.end = moment(value.end, 'DD-MM-YYYY').format('YYYY-MM-DD')
            setSelectedExpiryDateRange(value)
            setActiveFilterKey(null)
        } else {
            setSelectedExpiryDateRange(null)
            setActiveFilterKey(null)
        }
    }

    const handleNameChiSearch = (value: string) => {
        const trimmedValue = value.trim()
        if (!trimmedValue) {
            resetNameChi()
        }
        if (trimmedValue.length >= 10) {
            getNameChiOptions(trimmedValue, ListTypes.PoaList)
        }
    }

    const handleOpcsSearch = (value: string) => {
        const trimmedValue = value.trim()
        if (trimmedValue) {
            getNameOpcs4OperationsOptions(ListTypes.PoaList, trimmedValue)
        } else {
            resetOpcs()
        }
    }

    const handleSearchInputTextChange = useMemo(
        () =>
            debounce((type: string, value: string) => {
                switch (type) {
                    case 'nameChi':
                        handleNameChiSearch(value)
                        break
                    case 'operationProcedures':
                        handleOpcsSearch(value)
                        break
                }
            }, 300),
        []
    )

    const isFilterApplied = (code: string): boolean => {
        switch (code) {
            case 'priority':
                return !!selectedPriorities?.length
            case 'anae':
                return !!selectedAnae?.length
            case 'ipDsu':
                return !!selectedIpDsu?.length
            case 'hospital':
                return !!selectedHospital?.length
            case 'poaTypes':
                return !!selectedPoaTypes?.length
            case 'poaStatuses':
                return !!selectedPoaStatuses?.length
            case 'outcome':
                return !!selectedOutcome?.some((o) => o.value !== '0')
            case 'expiry':
                return !!selectedExpiryDateRange
            case 'nameChi':
                return !!selectedNameChi?.length
            case 'POADate':
                return !!selectedDateRange
            case 'scheduledDate':
                return !!selectedScheduledDateRange
            case 'operationProcedures':
                return !!selectedOperationProcedures?.length
            case 'poa':
                return (
                    !!selectedPoaStatusFilter?.length &&
                    !selectedPoaStatusFilter.some((s) => s.value === '0')
                )
            default:
                return false
        }
    }

    const isColumnSorted = (columnCode: string): boolean => {
        switch (columnCode) {
            case 'priority':
                return sortByColumn === 'Priority'
            case 'nameChi':
                return sortByColumn === 'Name'
            case 'operationProcedures':
                return sortByColumn === 'OPCSCode'
            case 'anae':
                return sortByColumn === 'Anae'
            case 'ipDsu':
                return sortByColumn === 'IPDSU'
            case 'expiry':
                return sortByColumn === 'ExpirationDate'
            case 'POADate':
                return sortByColumn === 'POADate'
            case 'scheduledDate':
                return sortByColumn === 'Scheduled'
            default:
                return false
        }
    }

    type PoaIconStatus = 'notStarted' | 'inProgress' | 'complete' | 'expired'

    const getPoaIconStatus = (poaListItem: any): PoaIconStatus => {
        const statusId = poaListItem?.questionnaireResponseStatusId
        const isExpired =
            getExpiryMeta(getRawExpiryValue(poaListItem)).isExpired ||
            statusId === QuestionnaireResponseStatus.Expired

        if (isExpired) {
            return 'expired'
        }
        if (statusId === QuestionnaireResponseStatus.Complete) {
            return 'complete'
        }
        if (statusId === QuestionnaireResponseStatus.POA) {
            return 'inProgress'
        }

        return 'notStarted'
    }

    const getPoaStatusIcons = (poaIconStatus: PoaIconStatus) => {
        switch (poaIconStatus) {
            case 'inProgress':
                return { defaultIcon: halfPale, hoverIcon: halfPaleHover }
            case 'complete':
                return { defaultIcon: fullPale, hoverIcon: fullPaleHover }
            case 'expired':
                return { defaultIcon: poaExpired, hoverIcon: poaExpiredHover }
            default:
                return { defaultIcon: pale, hoverIcon: pale }
        }
    }

    useEffect(() => {
        if (!hospitals?.length) return
        setHospitalOptions(
            hospitals.map((h) => ({
                value: String(h.id),
                label: h.name,
            }))
        )
    }, [hospitals])

    const displayedPoaData = poaData ?? []

    interface HoverIconButtonProps {
        defaultIcon: string
        hoverIcon: string
        onClick: () => void
        alt?: string
        className?: string
    }

    const HoverIconButton: FC<HoverIconButtonProps> = ({
        defaultIcon,
        hoverIcon,
        onClick,
        alt = 'icon',
        className = '',
    }) => {
        const [isHovered, setIsHovered] = useState(false)

        return (
            <div
                className={`${className} ${isHovered ? 'hovered' : ''}`}
                onClick={onClick}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                role="button"
            >
                {defaultIcon !== 'none' && (
                    <img src={isHovered ? hoverIcon : defaultIcon} alt={alt} />
                )}
            </div>
        )
    }

    return (
        <div className="poa-list-wrapper">
            <div className="poa-inner-wrapper">
            <div>
                <h1 className="poa-list-header">Pre-Operative Assessment (POA) list</h1>
            </div>

            <div className="poa-filters-wrapper" id="id-test">
                <div className="poa-filters">
                    <div className="poa-filters-search-wrapper">
                        <div className="relative w-full h-full">
                            <MultiSelect
                                options={specialityOptions}
                                handleChange={(selected: MultiValue<Option>) =>
                                    handleFilterChange('specialities', selected)
                                }
                                value={selectedSpecialities}
                                isInvalid={false}
                                placeholder={'Speciality'}
                                shouldSelectAllDefault = {true}
                                key={1}
                            />
                        </div>
                    </div>

                    <div className="poa-filters-search-wrapper">
                        <div className="relative w-full h-full">
                            <MultiSelect
                                options={surgeonOptions}
                                handleChange={(selected: MultiValue<Option>) =>
                                    handleFilterChange('surgeons', selected)
                                }
                                value={selectedSurgeons}
                                isInvalid={false}
                                placeholder={'Surgeon'}
                                shouldSelectAllDefault = {true}
                                key={2}
                            />
                        </div>
                    </div>

                    <div className="poa-filters-search-wrapper">
                        <div className="relative w-full h-full">
                            <MultiSelect
                                options={poaActionOptions}
                                handleChange={(selected: MultiValue<Option>) =>
                                    handleFilterChange('poaActions', selected)
                                }
                                value={selectedPoaActions}
                                isInvalid={false}
                                placeholder={'Actions'}
                                shouldSelectAllDefault = {false}
                                key={3}
                            />
                        </div>
                    </div>
                </div>

                <div className="poa-table-header">
                    <div className="poa-table-header-columns">
                        {headers.map((header) => (
                            <div
                                key={header.code}
                                className={`poa-table-header-column flex items-center justify-start ${header.code === 'separator' ? 'separator-column' : ''} ${header.code === 'operationProcedures' ? 'poa-table-opcs-column' : ''}`}
                            >
                                {header.code === 'separator' ? (
                                    <div className="separator-line" />
                                ) : (
                                    <>
                                <span
                                    onMouseEnter={() => setHoveredTitle(header.code)}
                                    onMouseLeave={() => setHoveredTitle(null)}
                                    className="poa-table-header-title"
                                >
                                    {header.title}
                                </span>
                                {header.icons.map((icon, i) =>
                                    icon === 'filter' ? (
                                        <div key={i} className="shrink-0">
                                            <div
                                                onMouseEnter={() =>
                                                    setHoveredTitle(header.code)
                                                }
                                                onMouseLeave={() =>
                                                    setHoveredTitle(null)
                                                }
                                                className={`filter-icon-wrap ${isFilterApplied(header.code) ? 'filter-applied' : ''} ${hoveredTitle === header.code ? 'hover-filter-applied' : ''}`}
                                            >
                                                <img
                                                    key={i}
                                                    src={filterBlack}
                                                    alt="Icon"
                                                    className="header-icons cursor-pointer"
                                                    onClick={() =>
                                                        handleToggleFilter(header.code)
                                                    }
                                                />
                                            </div>

                                            {activeFilterKey === header.code && (
                                                <div className="absolute">
                                                    {header.code === 'nameChi' ||
                                                    header.code ===
                                                        'operationProcedures' ? (
                                                        <MultiSelectPopUp
                                                            {...(header.menuPositionOffset && {
                                                                menuPositionOffset:
                                                                    header.menuPositionOffset,
                                                            })}
                                                            id={
                                                                header.code ===
                                                                'nameChi'
                                                                    ? 'filternamechi'
                                                                    : header.code ===
                                                                        'operationProcedures'
                                                                      ? 'operationprocedures'
                                                                      : ''
                                                            }
                                                            placeholder="Search"
                                                            isInValid={false}
                                                            propDivClasses={
                                                                header.code ===
                                                                'nameChi'
                                                                    ? 'filter-name-chi'
                                                                    : header.code ===
                                                                        'operationProcedures'
                                                                      ? 'filter-opcs-4-operation'
                                                                      : ''
                                                            }
                                                            handleCustomSearchInputTextChange={(
                                                                textValue: string
                                                            ) => {
                                                                handleSearchInputTextChange(
                                                                    header.code,
                                                                    textValue
                                                                )
                                                            }}
                                                            handleChange={(
                                                                selected: MultiValue<Option>
                                                            ) =>
                                                                handleFilterChange(
                                                                    header.code as keyof FilterMap,
                                                                    selected
                                                                )
                                                            }
                                                            value={
                                                                header.code ===
                                                                'nameChi'
                                                                    ? selectedNameChi
                                                                    : header.code ===
                                                                        'operationProcedures'
                                                                      ? selectedOperationProcedures
                                                                      : []
                                                            }
                                                            options={getOptionsByCode(
                                                                header.code
                                                            )}
                                                            inputValue={
                                                                header.code ===
                                                                'nameChi'
                                                                    ? nameChiSearchInput
                                                                    : opcsSearchInput
                                                            }
                                                            onInputValueChange={(
                                                                value: any
                                                            ) => {
                                                                if (
                                                                    header.code ===
                                                                    'nameChi'
                                                                ) {
                                                                    setNameChiSearchInput(
                                                                        value
                                                                    )
                                                                } else if (
                                                                    header.code ===
                                                                    'operationProcedures'
                                                                ) {
                                                                    setOpcsSearchInput(
                                                                        value
                                                                    )
                                                                }
                                                            }}
                                                        />
                                                    ) : header.code ===
                                                      'POADate' ? (
                                                        <div
                                                            className="date-picker-popup"
                                                            style={{
                                                                ...(header.menuPositionOffset?.top
                                                                    ? {
                                                                          top: header
                                                                              .menuPositionOffset
                                                                              .top,
                                                                      }
                                                                    : {}),
                                                                ...(header.menuPositionOffset?.left
                                                                    ? {
                                                                          left: header
                                                                              .menuPositionOffset
                                                                              .left,
                                                                      }
                                                                    : {}),
                                                                ...(header.menuPositionOffset?.transform
                                                                    ? {
                                                                          transform:
                                                                              header
                                                                                  .menuPositionOffset
                                                                                  .transform,
                                                                      }
                                                                    : {}),
                                                                ...(header.menuPositionOffset?.minWidth
                                                                    ? {
                                                                          minWidth: header
                                                                              .menuPositionOffset
                                                                              .minWidth,
                                                                      }
                                                                    : {}),
                                                            }}
                                                        >
                                                            <DateRange
                                                                initialDate={
                                                                    (selectedDateRange as DateRangeType) ??
                                                                    null
                                                                }
                                                                name={''}
                                                                onChange={
                                                                    handleDateRangeChange
                                                                }
                                                                propClasses={''}
                                                                isPatient={false}
                                                                calendarWidth={336}
                                                                defaultCalendarOpen
                                                            />
                                                        </div>
                                                    ) : header.code ===
                                                      'scheduledDate' ? (
                                                        <div
                                                            className="date-picker-popup"
                                                            style={{
                                                                ...(header.menuPositionOffset?.top
                                                                    ? {
                                                                          top: header
                                                                              .menuPositionOffset
                                                                              .top,
                                                                      }
                                                                    : {}),
                                                                ...(header.menuPositionOffset?.left
                                                                    ? {
                                                                          left: header
                                                                              .menuPositionOffset
                                                                              .left,
                                                                      }
                                                                    : {}),
                                                                ...(header.menuPositionOffset?.transform
                                                                    ? {
                                                                          transform:
                                                                              header
                                                                                  .menuPositionOffset
                                                                                  .transform,
                                                                      }
                                                                    : {}),
                                                                ...(header.menuPositionOffset?.minWidth
                                                                    ? {
                                                                          minWidth: header
                                                                              .menuPositionOffset
                                                                              .minWidth,
                                                                      }
                                                                    : {}),
                                                            }}
                                                        >
                                                            <DateRange
                                                                initialDate={
                                                                    (selectedScheduledDateRange as DateRangeType) ??
                                                                    null
                                                                }
                                                                name={''}
                                                                onChange={
                                                                    handleScheduledDateRangeChange
                                                                }
                                                                propClasses={''}
                                                                isPatient={false}
                                                                calendarWidth={336}
                                                                defaultCalendarOpen
                                                            />
                                                        </div>
                                                    ) : header.code ===
                                                      'expiry' ? (
                                                        <div
                                                            className="date-picker-popup expiry-date-picker-popup"
                                                            style={{
                                                                right: 'auto',
                                                                ...(header.menuPositionOffset?.top
                                                                    ? {
                                                                          top: header
                                                                              .menuPositionOffset
                                                                              .top,
                                                                      }
                                                                    : {}),
                                                                ...(header.menuPositionOffset?.left
                                                                    ? {
                                                                          left: header
                                                                              .menuPositionOffset
                                                                              .left,
                                                                      }
                                                                    : {}),
                                                                ...(header.menuPositionOffset?.transform
                                                                    ? {
                                                                          transform:
                                                                              header
                                                                                  .menuPositionOffset
                                                                                  .transform,
                                                                      }
                                                                    : {}),
                                                                ...(header.menuPositionOffset?.minWidth
                                                                    ? {
                                                                          minWidth: header
                                                                              .menuPositionOffset
                                                                              .minWidth,
                                                                      }
                                                                    : {}),
                                                            }}
                                                        >
                                                            <DateRange
                                                                initialDate={
                                                                    (selectedExpiryDateRange as DateRangeType) ??
                                                                    null
                                                                }
                                                                name={''}
                                                                onChange={
                                                                    handleExpiryDateRangeChange
                                                                }
                                                                propClasses={''}
                                                                isPatient={false}
                                                                calendarWidth={336}
                                                                defaultCalendarOpen
                                                            />
                                                        </div>
                                                    ) : (
                                                        <MultiSelectNoInput
                                                            {...(header.menuPositionOffset && {
                                                                menuPositionOffset:
                                                                    header.menuPositionOffset,
                                                            })}
                                                            handleChange={(
                                                                selected: MultiValue<Option>
                                                            ) => {
                                                                handleFilterChange(
                                                                    header.code as keyof FilterMap,
                                                                    selected
                                                                )
                                                            }}
                                                            value={
                                                                getSelectedValue(
                                                                    header.code
                                                                ) || []
                                                            }
                                                            options={getOptionsByCode(
                                                                header.code
                                                            )}
                                                            keepMenuOpen={true}
                                                            isOpen={
                                                                activeFilterKey ===
                                                                header.code
                                                            }
                                                            onClose={() =>
                                                                setActiveFilterKey(
                                                                    null
                                                                )
                                                            }
                                                        />
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div
                                            className={`flex flex-col sort-icon sort-icon-wrap cursor-pointer ${hoveredTitle === `sort-${header.code}` ? 'hover-filter-applied' : ''}`}
                                            onMouseEnter={() =>
                                                setHoveredTitle(`sort-${header.code}`)
                                            }
                                            onMouseLeave={() =>
                                                setHoveredTitle(null)
                                            }
                                            onClick={() =>
                                                toggleSort(header.sortKey)
                                            }
                                        >
                                            <div className="sort-arrow-up-spacing">
                                                <UpArrowBlack
                                                    className={`${isColumnSorted(header.code) && sortOrder === 'desc' ? 'arrow-dimmed' : 'arrow-bright'}`}
                                                />
                                            </div>
                                            <div className="sort-arrow-down-spacing">
                                                <DownArrowBlack
                                                    className={`${isColumnSorted(header.code) && sortOrder === 'asc' ? 'arrow-dimmed' : 'arrow-bright'}`}
                                                />
                                            </div>
                                        </div>
                                    )
                                )}
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="poa-body-wrapper">
                {displayedPoaData?.length > 0 &&
                    displayedPoaData.map((poaListItem: any, index: number) => (
                        <React.Fragment key={poaListItem.id + index}>
                            <div
                                className={`poa-table-body ${index === 0 ? 'first-row' : ''}`}
                            >
                                <div className="poa-table-body-column">
                                    {poaListItem.priority}
                                </div>
                                <div className="poa-table-body-column">
                                    <div
                                        style={{ fontWeight: 600 }}
                                    >{` ${poaListItem.surname}, ${poaListItem.forename}`}</div> 
                                    <div>{poaListItem.chiNumber}</div>
                                    <div className="flex items-center gap-2">
                                        <img src={telephone} alt="Phone Icon" />
                                        <span>{poaListItem.mobileNumber}</span>
                                    </div>
                                    <div className="group flex items-center gap-2 min-w-0">
                                        <img src={email} alt="Email Icon" className="flex-shrink-0" />
                                        <span className="truncate">{poaListItem.email}</span>
                                        {poaListItem.email && <img
                                            src={copy}
                                            alt="Copy Email"
                                            className="flex-shrink-0 cursor-pointer opacity-0 transition-opacity duration-150 group-hover:opacity-100"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                copyToClipboard(poaListItem.email);
                                            }}
                                        />}
                                    </div>
                                </div>
                                <div className="poa-table-body-column poa-table-opcs-column">
                                    {poaListItem?.opcsCode +
                                        ' - ' +
                                        poaListItem.operationProcedure}
                                </div>
                                <div className="poa-table-body-column">
                                    {(poaListItem?.operationDate ?? poaListItem?.operationListDate)
                                        ? dayjs
                                              .utc(
                                                  poaListItem?.operationDate ??
                                                      poaListItem?.operationListDate
                                              )
                                              .local()
                                              .format('DD/MM/YYYY')
                                        : '--'}
                                </div>
                                <div className="poa-table-body-column poa-table-hospital-column">
                                    {getHospitalValue(poaListItem)}
                                </div>
                                <div className="poa-table-body-column">
                                    {poaListItem.anaestheticType}
                                </div>
                                <div className="poa-table-body-column">
                                    {(poaListItem?.intendedManagementReferenceCode ??
                                        poaListItem?.operationListManagementValue)
                                        ? (poaListItem?.intendedManagementReferenceCode ??
                                            poaListItem?.operationListManagementValue)
                                        : '--'}
                                </div>
                                <div className="poa-table-body-column separator-column">
                                    <div className="separator-line" />
                                </div>

                                <div className="poa-table-body-column">
                                    {(() => {
                                        const poaDateTime =
                                            poaListItem?.questionnaireResponsePOADateTime
                                        const hasPoaDateTime = poaDateTime != null
                                        const dateDisplay = hasPoaDateTime
                                            ? dayjs
                                                  .utc(poaDateTime)
                                                  .local()
                                                  .format('DD/MM/YYYY')
                                            : 'dd/mm/yyyy'
                                        const timeDisplay = hasPoaDateTime
                                            ? dayjs
                                                  .utc(poaDateTime)
                                                  .local()
                                                  .format('h:mm A')
                                            : '00:00'

                                        return (
                                            <>
                                                <div
                                                    className={
                                                        !hasPoaDateTime
                                                            ? 'poa-appt-placeholder'
                                                            : undefined
                                                    }
                                                >
                                                    {dateDisplay}
                                                </div>
                                                <div
                                                    className={
                                                        !hasPoaDateTime
                                                            ? 'poa-appt-placeholder'
                                                            : undefined
                                                    }
                                                >
                                                    {timeDisplay}
                                                </div>
                                                <div>
                                                    <img
                                                        className="cursor-pointer mt-1"
                                                        src={calanderPoa}
                                                        width={12}
                                                        height={14}
                                                        onClick={() => {
                                                            setQuestionnaireResponseId(
                                                                poaListItem.questionnaireResponseId
                                                            )
                                                            setWaitingListRecordId(
                                                                poaListItem.id
                                                            )
                                                            setName(
                                                                `${poaListItem.surname}, ${poaListItem.forename}`  
                                                            )
                                                            setModalSelection(
                                                                poaListItem.questionnaireResponsePOAType
                                                            )
                                                            setpoaListSelectedPoaDate(
                                                                poaListItem?.questionnaireResponsePOADateTime
                                                            )
                                                            openModal()
                                                        }}
                                                    />
                                                </div>
                                            </>
                                        )
                                    })()}
                                </div>

                                <div className="poa-table-body-column flex">
                                    <div className="move-to-poa-icons-wrapper">
                                        <div className="link-icon-poa">
                                            <HoverIconButton
                                                className="bell-icon"
                                                defaultIcon={
                                                    poaListItem.questionnaireResponsePOAType ===
                                                    POATypes.PhoneCall
                                                        ? caller
                                                        : poaListItem.questionnaireResponsePOAType ===
                                                            POATypes.FaceToFace
                                                          ? group
                                                          : 'none'
                                                }
                                                hoverIcon={
                                                    poaListItem.questionnaireResponsePOAType ===
                                                    POATypes.PhoneCall
                                                        ? callerWhite
                                                        : poaListItem.questionnaireResponsePOAType ===
                                                            POATypes.FaceToFace
                                                          ? groupWhite
                                                          : 'none'
                                                }
                                                alt="Bell Icon"
                                                onClick={() => {
                                                    setQuestionnaireResponseId(
                                                        poaListItem.questionnaireResponseId
                                                    )
                                                    setWaitingListRecordId(
                                                        poaListItem.id
                                                    )
                                                    setName(
                                                        `${poaListItem.surname}, ${poaListItem.forename}`  
                                                    )
                                                    setModalSelection(
                                                        poaListItem.questionnaireResponsePOAType
                                                    )
                                                    setpoaListSelectedPoaDate(
                                                        poaListItem?.questionnaireResponsePOADateTime
                                                    )
                                                    openModal()
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="poa-table-body-column">
                                    {getOutcomeValue(poaListItem)}
                                </div>

                                <div className="poa-table-body-column">
                                    {(() => {
                                        const expiryMeta = getExpiryMeta(
                                            getRawExpiryValue(poaListItem)
                                        )
                                        const { display } = expiryMeta
                                        const isExpired =
                                            expiryMeta.isExpired ||
                                            poaListItem?.questionnaireResponseStatusId ===
                                                QuestionnaireResponseStatus.Expired

                                        if (display === '--' && !isExpired) {
                                            return '--'
                                        }

                                        return (
                                            <span
                                                className={
                                                    isExpired
                                                        ? 'poa-expiry--expired'
                                                        : undefined
                                                }
                                            >
                                                <div>{display}</div>
                                                {isExpired && (
                                                    <div>
                                                        <strong>Expired</strong>
                                                    </div>
                                                )}
                                            </span>
                                        )
                                    })()}
                                </div>

                                <div className="poa-table-body-column flex">
                                    <div className="questionnaire-wrapper">
                                        {(() => {
                                            const poaIconStatus =
                                                getPoaIconStatus(poaListItem)
                                            const { defaultIcon, hoverIcon } =
                                                getPoaStatusIcons(poaIconStatus)
                                            return (
                                        <HoverIconButton
                                            className="bell-icon"
                                            defaultIcon={defaultIcon}
                                            hoverIcon={hoverIcon}
                                            alt="Bell Icon"
                                            onClick={() =>
                                                navigateToPoa(
                                                    poaListItem.questionnaireId,
                                                    poaListItem.questionnaireResponseId,
                                                    poaListItem.questionnaireResponseInformaitionPackId,
                                                    poaListItem.questionnaireResponseStatusId,
                                                    poaListItem.id
                                                )
                                            }
                                        />
                                            )
                                        })()}
                                    </div>
                                </div>
                            </div>
                            <div className="poa-list-action-container">
                                <div className="poa-list-action-scroll">
                                    {poaListItem.actions?.map(
                                        (
                                            actionItem: any,
                                            actionIndex: number
                                        ) => (
                                            <div
                                                key={actionIndex}
                                                className="poa-list-action-pill"
                                            >
                                                {actionItem.name}
                                                {actionItem.status === true && (
                                                    <img
                                                        src={actionComplete}
                                                        alt="Action Completed"
                                                    />
                                                )}
                                                {actionItem.status ===
                                                    false && (
                                                    <img
                                                        src={action}
                                                        alt="Action incompleted"
                                                    />
                                                )}
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>

                            {index !== displayedPoaData.length - 1 && (
                                <div className="divider"></div>
                            )}
                        </React.Fragment>
                    ))}
            </div>
            <PoaListModal
                isOpen={isModalOpen}
                onClose={closeModal}
                modalSelection={modalSelection}
                name={name}
                questionnaireResponseId={questionnaireResponseId}
                waitingListRecordId={waitingListRecordId}
                existingPOADateTime={new Date(poaListSelectedPoaDate)}
                submitButtonText="Update appointment"
                type={ListTypes.PoaList}
            />
            </div>
        </div>
    )
})

export default PoaList
